import React from "react";
import { withActions } from "containers/HOC";
import { Link } from "react-router-dom";
import * as utils from "common/utils";
import ActionLink from "components/ActionLink";
import { createWorkingCopy } from "./_actions";
import { ManagePublicationActionLink, AddPublicationCommentActionLink, ViewPublicationHistoryActionLink, isPublicationLocked } from "containers/Publications";

const PublicationActionsBar = (props) => {
    const { online, farm, publication, createWorkingCopy } = props;

    const isLocked = isPublicationLocked(publication);

    const _createWorkingCopy = () => {
        createWorkingCopy(publication);
    };

    const workingCopyBudget = (farm.offlineBudgets || []).find((ob) => ob.budget.id === publication.workingCopyId);
    const canCreateWorkingCopy = !workingCopyBudget && utils.canCreateWorkingCopy(farm) && !publication.farmGroupId;

    return (
        <div className="ActionsBar ActionsBar--super u-print-none">
            <div className="ActionsBar-left">
                <ul className="ActionsBar-links">
                    {workingCopyBudget && (
                        <li>
                            <Link to={`/app/farm/${workingCopyBudget.farmId}/analysis/${workingCopyBudget.id}`} className="IconLink--edit" id="edit-working-copy">
                                Working copy
                            </Link>
                        </li>
                    )}
                    {canCreateWorkingCopy && (
                        <li>
                            <ActionLink onClick={_createWorkingCopy} className="IconLink--edit" id="create-working-copy">
                                Working copy
                            </ActionLink>
                        </li>
                    )}
                    {online && (
                        <li>
                            <ViewPublicationHistoryActionLink publication={publication} />
                        </li>
                    )}

                    {!isLocked && (
                        <li>
                            <ManagePublicationActionLink publication={publication} />
                        </li>
                    )}
                    <li>
                        <AddPublicationCommentActionLink publication={publication} label="Add publication comment" />
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default withActions({ createWorkingCopy })(PublicationActionsBar);
